export const videoIcons: Record<number, { iconResult: string; iconGuarantee: string }> = {
  1: { iconResult: 'ri-heart-line', iconGuarantee: 'ri-shield-check-line' },
  2: { iconResult: 'ri-sparkling-line', iconGuarantee: 'ri-shield-check-line' },
  3: { iconResult: 'ri-magic-line', iconGuarantee: 'ri-shield-check-line' },
  4: { iconResult: 'ri-brush-line', iconGuarantee: 'ri-shield-check-line' },
  5: { iconResult: 'ri-palette-line', iconGuarantee: 'ri-shield-check-line' },
  6: { iconResult: 'ri-drop-line', iconGuarantee: 'ri-shield-check-line' },
  7: { iconResult: 'ri-sun-line', iconGuarantee: 'ri-shield-check-line' },
  8: { iconResult: 'ri-windy-line', iconGuarantee: 'ri-shield-check-line' },
  9: { iconResult: 'ri-flashlight-line', iconGuarantee: 'ri-shield-check-line' },
  10: { iconResult: 'ri-vip-diamond-line', iconGuarantee: 'ri-shield-check-line' },
  11: { iconResult: 'ri-scissors-line', iconGuarantee: 'ri-shield-check-line' },
  12: { iconResult: 'ri-vip-crown-line', iconGuarantee: 'ri-shield-check-line' },
  13: { iconResult: 'ri-water-flash-line', iconGuarantee: 'ri-shield-check-line' },
  14: { iconResult: 'ri-star-line', iconGuarantee: 'ri-shield-check-line' },
  15: { iconResult: 'ri-fire-line', iconGuarantee: 'ri-shield-check-line' },
};